/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BattleCurve.css';
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'

// console.log(ReactEcharts)

const list = [
  {
    class: '总值',
    type: 'total'
  }, {
    class: '微信',
    type: 'wx'
  }, {
    class: '微博',
    type: 'wb'
  }, {
    class: '知乎',
    type: 'zh'
  }, {
    class: '今日头条',
    type: 'tt'
  }
]

const list2 = [
  {
    class: '好感度',
    type: 'Fa'
  }, {
    class: '传播度',
    type: 'Sp'
  }, {
    class: '参与度',
    type: 'Pa'
  }
]

class BattleCurve extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      active: 'total',
      type: 'Fa'
    }
    // this.data=propsData[`${this.state.active}Data${this.state.type}`]
    this.getOption = this
      .getOption
      .bind(this)
  }

  getOption = () => {

  

    let propsData =this.props.json|| [
      {
        name: '腾讯',
        totalDataFa: [48.56, 47.79, 44.46, 47.38, 47.87, 47.92, 48.01, 48.04, 48.01, 48.01, 48.03, 48.06, 48.11, 48.15, 44.62, 44.69, 44.74, 44.78, 45.35, 45.34, 45.4, 45.43, 45.44, 45.49, 45.52, 45.52, 45.54, 45.54, 45.73, 45.71],
        totalDataPa: [62.09, 58.87, 58.72, 58.81, 59.12, 60.04, 61.17, 62.33, 64.05, 65.19, 64.98, 64.74, 65.15, 64.84, 64.78, 65.18, 66.04, 66.75, 64.95, 64.06, 63.57, 64.45, 65.53, 65.92, 65.62, 65.46, 65.39, 66.04, 66.93, 66.89],
        totalDataSp: [74.81, 72.07, 72.67, 73.21, 73.96, 75.34, 76.1, 77.32, 78.77, 79.45, 79.77, 79.57, 79.39, 79.77, 80.28, 80.15, 79.94, 80.04, 78.41, 77.31, 76.19, 75.75, 75.65, 75.36, 75.7, 75.65, 78.06, 78.48, 79.36, 79.75],
        ttDataFa: [34.28, 34.41, 34.27, 33.99, 33.79, 33.8, 33.74, 33.79, 33.71, 33.53, 33.44, 33.44, 33.51, 33.51, 33.44, 33.48, 33.53, 33.62, 33.67, 33.66, 33.9, 33.98, 34.04, 34.16, 34.21, 34.34, 34.37, 34.44, 35.33, 35.29],
        ttDataPa: [37.94, 36.56, 36.71, 36.95, 37.36, 38.09, 38.81, 40.31, 42.27, 43.25, 43.81, 43.84, 45.16, 44.73, 45.03, 45.75, 45.97, 46.43, 43.72, 44.53, 46.36, 47.36, 49.12, 50.14, 50.85, 50.75, 50.87, 52.29, 55.64, 55.71],
        ttDataSp: [39.68, 39.19, 41.71, 40.96, 40.56, 40.26, 39.2, 38.6, 39.42, 39.28, 41.03, 40.82, 41.65, 44.34, 45.21, 45.63, 44.06, 44.46, 40.96, 40.62, 40.65, 37.75, 36.79, 36.22, 39.16, 37.78, 39.91, 38.7, 42.75, 43.35],
        wbDataFa: [57.63, 57.77, 57.99, 58.16, 58.31, 58.43, 58.53, 58.62, 58.69, 58.84, 59.01, 59.11, 59.2, 59.3, 59.47, 59.65, 59.75, 59.82, 59.83, 59.83, 59.83, 59.88, 59.98, 60.08, 60.18, 60.14, 60.15, 60.13, 60.18, 60.18],
        wbDataPa: [37.67, 36.48, 36.19, 36.25, 36.44, 37.19, 38.07, 38.52, 38.99, 38.85, 38.12, 37.54, 37.02, 35.88, 34.82, 34.87, 36.93, 39.46, 39.73, 37.91, 36.34, 36.06, 35.57, 35.2, 34.39, 34.03, 33.98, 33.91, 33.77, 33.56],
        wbDataSp: [69.52, 68.54, 68.9, 69.31, 69.83, 72.29, 74.08, 75.15, 75.33, 75.99, 75.93, 76.27, 75.91, 75.91, 76.88, 75.84, 75.6, 75.55, 74.84, 72.68, 70.14, 69.56, 69.06, 68.9, 68.64, 69.23, 71.65, 73.53, 74.89, 75.87],
        wxDataFa: [61.84, 61.8, 61.81, 61.82, 61.8, 61.79, 61.81, 61.79, 61.66, 61.62, 61.58, 61.56, 61.57, 61.58, 61.58, 61.59, 61.59, 61.59, 61.58, 61.56, 61.56, 61.55, 61.44, 61.37, 61.33, 61.28, 61.23, 61.23, 61.21, 61.21],
        wxDataPa: [89.5, 82.25, 82.04, 82.08, 82.56, 84.01, 85.95, 87.95, 91.29, 94.11, 93.93, 93.81, 94.75, 95.25, 95.97, 96.64, 96.92, 96.16, 95.4, 94.71, 93.98, 96.06, 98.65, 100, 100, 100, 100, 100, 100, 100],
        wxDataSp: [92.96, 86.41, 86.33, 87.89, 89.74, 91.38, 92.39, 95.13, 98.63, 100, 99.97, 99.16, 98.55, 98.1, 98.1, 98.51, 99.04, 99.15, 99.49, 99.4, 98.46, 99.07, 99.98, 100, 100, 100, 100, 100, 100, 100],
        zhDataFa: [-1.13, -9.48, -43.23, -14.11, -9.23, -9.24, -8.61, -8.6, -8.6, -8.6, -8.61, -8.61, -8.61, -8.6, -44.4, -44.4, -44.35, -44.31, -38.76, -38.75, -38.72, -38.66, -38.68, -38.51, -38.44, -38.42, -38.2, -38.21, -38.25, -38.34],
        zhDataPa: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 89.08, 87.37, 86.89, 87.34, 87.34, 85.66, 84.18, 84.04, 83.24, 87.12, 89.82, 90.03],
        zhDataSp: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 92.03, 89.57, 90.52, 91.81, 91.3, 90.06, 88.45, 88.61, 100, 100, 96, 95.28]
      }, {
        name: '阿里巴巴',
        totalDataFa:[44.17, 44.22, 44.24, 44.28, 44.22, 44.18, 44.17, 44.1, 44.06, 44.05, 44.09, 42.54, 42.53, 42.55, 42.52, 42.75, 42.77, 42.78, 42.78, 42.83, 42.89, 42.61, 42.51, 42.44, 42.5, 42.62, 42.6, 42.51, 42.5, 42.47],
        totalDataPa:[22.97, 23.23, 23.4, 24.12, 25.02, 25.28, 25.76, 25.68, 25.38, 25.37, 25.49, 26.15, 26.41, 26.86, 26.87, 26.47, 26.21, 26.17, 26.15, 26.48, 26.63, 26.87, 27.12, 27.38, 26.88, 26.6, 26.08, 26.22, 25.91, 25.65],
        totalDataSp:[23.32, 23.18, 23.69, 24.89, 25.43, 25.82, 25.89, 25.84, 25.84, 26.24, 27.2, 27.72, 28.06, 27.76, 27.43, 26.09, 25.81, 25.35, 24.53, 24.39, 24.31, 26.49, 26.53, 26.51, 25.9, 25.4, 25.22, 25.3, 24.22, 24.12],
        ttDataFa:[50.05, 49.93, 50.04, 49.97, 49.81, 49.86, 49.81, 49.61, 49.49, 49.42, 49.5, 49.43, 49.36, 49.36, 49.23, 49.17, 49.23, 49.23, 49.24, 49.49, 49.76, 49.67, 49.86, 49.6, 49.92, 50.44, 50.43, 50.43, 50.43, 50.43],
        ttDataPa:[24.93, 24.98, 25.26, 26.23, 27.21, 26.88, 27.49, 27.76, 27.88, 28.12, 28.23, 30.1, 30.12, 30.27, 29.95, 29.36, 29.18, 29.6, 29.98, 31.49, 32.77, 33.74, 34.62, 35.45, 36.69, 37.17, 35.94, 34.62, 33.52, 32.43],
        ttDataSp:[33.31, 32.73, 33.55, 35.46, 35.01, 35.28, 35.68, 35.91, 35.98, 37.39, 40.87, 41.24, 41.76, 40.58, 39.56, 36.89, 36.13, 34.07, 30.22, 29.73, 29.72, 28.51, 28.47, 28.82, 28.41, 28.45, 29.15, 29.8, 30.69, 31.81],
        wbDataFa:[41.74, 41.69, 41.68, 41.77, 41.63, 41.54, 41.53, 41.46, 41.43, 41.46, 41.52, 41.4, 41.41, 41.44, 41.42, 41.42, 41.42, 41.47, 41.45, 41.46, 41.46, 41.45, 41.39, 41.39, 41.39, 41.42, 41.39, 41.3, 41.23, 41.18],
        wbDataPa:[5.17, 5.12, 5.23, 5.51, 5.71, 5.89, 6, 5.91, 5.77, 5.78, 5.79, 5.76, 5.79, 6.13, 6.5, 6.49, 6.44, 6.51, 6.48, 6.54, 6.53, 6.31, 6.12, 6.05, 5.74, 5.59, 5.27, 5.24, 5.17, 5.16],
        wbDataSp:[6.88, 6.81, 6.92, 7.27, 7.55, 7.51, 7.53, 7.58, 7.54, 7.67, 8.02, 8.5, 8.66, 8.51, 8.4, 8.18, 8.04, 8.08, 7.86, 7.73, 7.75, 7.84, 7.84, 7.9, 7.8, 7.78, 7.59, 7.56, 7.53, 7.5],
        wxDataFa:[57.17, 57.18, 57.18, 57.2, 57.23, 57.19, 57.2, 57.2, 57.18, 57.16, 57.17, 57.17, 57.17, 57.17, 57.17, 57.17, 57.17, 57.18, 57.19, 57.2, 57.21, 57.21, 57.2, 57.21, 57.21, 57.22, 57.23, 57.21, 57.2, 57.18],
        wxDataPa:[42.44, 42.24, 42.28, 43.09, 44.33, 44.74, 45.51, 45.24, 45.24, 45.66, 46.02, 46.74, 47.4, 48.13, 47.91, 47.29, 46.73, 46.33, 46.07, 46.17, 45.97, 45.59, 45.39, 44.95, 43.21, 42.38, 41.99, 43.77, 44.12, 44.36],
        wxDataSp:[31.1, 30.39, 30.51, 31.26, 32.09, 33.45, 34.34, 34.99, 35.48, 35.71, 35.8, 36.25, 36.75, 37.1, 37.04, 37.09, 37.06, 36.76, 36.69, 36.86, 36.63, 36.57, 36.54, 36.53, 36.1, 35.97, 36, 36.15, 36.24, 36.37],
        zhDataFa:[-4.64, -3.74, -3.74, -3.45, -3.45, -3.47, -3.47, -3.48, -3.48, -3.48, -3.51, -18.42, -18.42, -18.31, -18.31, -15.87, -15.86, -15.94, -15.94, -15.97, -15.93, -18.57, -19.68, -19.91, -19.99, -19.99, -20.09, -20.51, -20.38, -20.44],
        zhDataPa:[13.21, 16.53, 17.18, 18.59, 20.69, 21.85, 22.38, 22.21, 19.51, 17.48, 17.13, 17.56, 17.74, 18.16, 18.33, 17.76, 17.67, 17.53, 17.61, 17.39, 17.01, 19.58, 21.69, 24.45, 24.09, 23.77, 23.5, 21.47, 19.58, 18.3],
        zhDataSp:[33.58, 36.1, 38.83, 43.14, 45.58, 44.32, 40.95, 37.55, 35.91, 35.81, 36.86, 38.1, 38.21, 36.83, 36.11, 28.66, 28.04, 28.42, 28.92, 28.33, 28.32, 52.43, 53.07, 52.01, 48.56, 43.98, 41.36, 40.36, 27.67, 24.03]
      }
    ]

    let legendArr = []

    propsData.forEach((i) => {
      legendArr.push(i.name)
    })

    const timeArr = []

    const m = (this.props.time.substring(5, 7)) - 1
    const d = Number(this.props.time.substring(8, 10)) + 1
    let time = moment().set({'month': m, 'date': d})
    for (var i = 0; i < 30; i++) {
      timeArr.unshift(time.subtract(1, 'days').format('MM-DD'))
    }


    const option = {
      title: {
        text: `三维曲线图 - ${legendArr.join(' vs ')}`,
        subtext: '数据来源：数字品牌榜',
        // sublink:'',
        x: '20'
      },
      color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
      
      legend: {
        data: legendArr,
        right: 10,
        bottom: 10,
        orient: 'vertical',
      },
      toolbox: {
        show: true,
        feature: {
            restore: {},
            saveAsImage: {}
        },
        right: 20
    },
    grid: {
      left: '3%',
      right: '15%',
      bottom: '3%',
      containLabel: true
  },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        data: timeArr,
        type: 'category',
        silent: false,
        splitLine: {
          show: false
        }
      },
      yAxis: [
        {
          type: 'value',
          boundaryGap: [0.2, 0.2]
        }

      ],
      series: propsData.map((i) => {
        return {
          name: i.name,
          // data: i[this.state.active],
          data:i[`${this.state.active}Data${this.state.type}`],
          type: 'line',
          animationDelay: function (idx) {
            return idx * 10 + 100;
          }
        }

      }),
      animationEasing: 'elasticOut',
      animationDelayUpdate: function (idx) {
        return idx * 5;
      }
    };
    return option
  }

  render() {

    const {active} = this.state

    return (

      <div className={s.root}>
       
        <select
          onChange={(e) => this.setState({active: e.target.value})}
          className={s.selectLayout}
          value={this.state.active}
          >

          {list.map((i) => {
            return (
              <option key={i.type} value={i.type} >{i.class}</option>
            )
          })}
        </select>
        <select
          onChange={(e) => this.setState({type: e.target.value})}
          value={this.state.type}
          className={s.selectLayout2}>
          {list2.map((i) => {
            return (
              <option key={i.type} value={i.type} >{i.class}</option>
            )
          })}
        </select>

        <ReactEcharts
          option={this.getOption()}
          style={{
          height: '550px',
          width: '100%',
          
          borderRadius: '4px'
        }}
          className={s.charts}
          notMerge={true}
          lazyUpdate={true}
          theme={"theme_name"}
          onChartReady={this.onChartReadyCallback}/>
      </div>

    )

  }
}

export default withStyles(s)(BattleCurve);



// WEBPACK FOOTER //
// src/components/BattleCurve/BattleCurve.js